<template>
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.25439 6.36416L5.77535 8.86221L14.5999 0.117831C14.8541 -0.134094 15.2889 0.044843 15.2889 0.400363L15.2889 5.31172C15.2889 5.41767 15.2462 5.51891 15.1701 5.59426L5.96068 14.7201C5.80149 14.8778 5.5425 14.8754 5.38568 14.7153L0.113291 9.30485C-0.0435267 9.14475 -0.0363983 8.88811 0.127547 8.73507L2.69127 6.35474C2.85047 6.20641 3.09995 6.21112 3.25202 6.36416L3.25439 6.36416Z"
            fill="currentColor"
        />
    </svg>
</template>
